// ui/snippets/topBar/StatsItem.tsx
import { Skeleton, Flex, Box, useColorModeValue, chakra } from '@chakra-ui/react';
import React from 'react';
import type { IconName } from 'ui/shared/IconSvg';
import IconSvg from 'ui/shared/IconSvg';

type Props = {
  icon?: IconName | React.ReactNode;
  title: string | React.ReactNode;
  value: string | React.ReactNode;
  className?: string;
  tooltip?: React.ReactNode;   // 👈 chỉ card nào truyền thì mới có
  url?: string;
  isLoading?: boolean;
};

const StatsItem = ({ icon, title, value, className, tooltip, url, isLoading }: Props) => {
  return (
    <Flex
      position="relative"
      px={{ base: 3, lg: 4 }}
      py={{ base: 2, lg: 3 }}
      /** 👇 chừa chỗ bên phải nếu có tooltip */
      pr={{ base: tooltip ? 8 : 3, lg: tooltip ? 10 : 4 }}
      borderRadius="10px"
      flexDirection="row"
      alignItems="center"
      columnGap={{ base: 2.5, lg: 3 }}
      boxShadow="0 1px 3px 0 #e0e0e0"
      minH={{ base: '70px', lg: '80px' }}
      {...(url && !isLoading ? ({ as: 'a' as const, href: url }) : {})}
      className={className}
    >
      {/* Icon trái */}
      <Flex alignItems="center" justifyContent="center" flexShrink={0}>
        {typeof icon === 'string' || !icon
          ? <IconSvg name={(icon as IconName) ?? 'info'} boxSize={{ base: 6, lg: 8 }} />
          : icon}
      </Flex>

      {/* Text */}
      <Flex flexDirection="column" alignItems="flex-start" w="100%">
        <Skeleton isLoaded={!isLoading} color="#6B7280" fontSize={{ base: '12px', lg: '13px' }} lineHeight="16px">
          {typeof title === 'string' ? <span>{title}</span> : title}
        </Skeleton>
        <Skeleton isLoaded={!isLoading} fontWeight={400} fontSize={{ base: '15px', lg: '16px' }}>
          {typeof value === 'string' ? <span>{value}</span> : value}
        </Skeleton>
      </Flex>

      {/* 👇 Nút i: căn giữa dọc, sát mép phải giống hình bên phải */}
      {tooltip && (
        <Box
          position="absolute"
          right={{ base: '10px', lg: '12px' }}
          top="50%"
          transform="translateY(-50%)"
          display="flex"
          alignItems="center"
          zIndex={1}
        >
          {tooltip}
        </Box>
      )}
    </Flex>
  );
};

export default chakra(StatsItem);

// import type { SystemStyleObject } from '@chakra-ui/react';
// import { Skeleton, Flex, useColorModeValue, chakra } from '@chakra-ui/react';
// import React from 'react';

// import breakpoints from 'theme/foundations/breakpoints';
// import type { IconName } from 'ui/shared/IconSvg';
// import IconSvg from 'ui/shared/IconSvg';

// type Props = {
//   /** Cho phép truyền tên icon (IconName) hoặc 1 ReactNode tuỳ biến (vd: <chakra.img />) */
//   icon?: IconName | React.ReactNode;
//   /** Cho phép title là string hoặc node (để custom font-size, weight...) */
//   title: string | React.ReactNode;
//   /** Value đã hỗ trợ string | ReactNode như cũ */
//   value: string | React.ReactNode;
//   className?: string;
//   tooltip?: React.ReactNode;
//   url?: string;
//   isLoading?: boolean;
// };

// const LARGEST_BREAKPOINT = '1800px';

// const StatsItem = ({ icon, title, value, className, tooltip, url, isLoading }: Props) => {
//   const sxContainer: SystemStyleObject = {
//     [`@media screen and (min-width: ${breakpoints.lg}) and (max-width: ${LARGEST_BREAKPOINT})`]: {
//       flexDirection: 'column',       // icon trên, text dưới (giống các card khác)
//       alignItems: 'center',          // căn giữa toàn bộ item khi dạng cột
//       textAlign: 'center',
//       rowGap: 3,
//     },
//   };

//   const sxText: SystemStyleObject = {
//     [`@media screen and (min-width: ${breakpoints.lg}) and (max-width: ${LARGEST_BREAKPOINT})`]: {
//       alignItems: 'center',          // căn giữa khối text khi dạng cột
//     },
//   };

//   const sxIconWrap: SystemStyleObject = {
//     alignSelf: 'center',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     // khi chuyển sang cột thì icon nằm giữa theo chiều ngang
//     [`@media screen and (min-width: ${breakpoints.lg}) and (max-width: ${LARGEST_BREAKPOINT})`]: {
//       marginBottom: '8px',
//     },
//   };

//   const loadingBgColor = useColorModeValue('blackAlpha.50', 'whiteAlpha.50');

//   return (
//     <Flex
//       px={{ base: 3, lg: 5 }}
//       py={{ base: 3, lg: 7 }}
//       borderRadius="10px"
//       flexDirection="row"
//       sx={sxContainer}
//       alignItems="center"
//       columnGap={{ base: 3, lg: 5 }}
//       rowGap={2}
//       className={className}
//       position="relative"
//       {...(url && !isLoading
//         ? {
//             as: 'a' as const,
//             href: url,
//           }
//         : {})}
//       boxShadow={'0 1px 5px 0 #dadce0'}
//     >
//       {/* ICON SLOT */}
//       <Flex sx={sxIconWrap}>
//         {typeof icon === 'string' || icon === undefined ? (
//           <IconSvg name={(icon as IconName) ?? 'info'} boxSize={{ base: 7, lg: 12 }} isLoading={isLoading} borderRadius="base" />
//         ) : (
//           // ReactNode custom (vd: <chakra.img />)
//           icon
//         )}
//       </Flex>

//       {/* TEXT */}
//       <Flex flexDirection="column" alignItems="start" sx={sxText}>
//         <Skeleton isLoaded={!isLoading} color="#000" fontSize={{ base: 'xs', lg: 'md' }} lineHeight="16px" borderRadius="base">
//           {typeof title === 'string' ? <span>{title}</span> : title}
//         </Skeleton>
//         <Skeleton
//           isLoaded={!isLoading}
//           fontWeight={500}
//           fontSize={{ base: 'md', lg: 'xl' }}
//           color={useColorModeValue('black', 'white')}
//           borderRadius="base"
//         >
//           {typeof value === 'string' ? <span>{value}</span> : value}
//         </Skeleton>
//       </Flex>

//       {tooltip}
//     </Flex>
//   );
// };

// export default chakra(StatsItem);
